import React from 'react'
import { Person } from 'react-bootstrap-icons'

export default function AvatarStack({ avatars = [], maxVisible = 4 }) {
  const visibleAvatars = avatars.slice(0, maxVisible)
  const overflowCount = avatars.length - maxVisible

  if (avatars.length === 0) return null

  return (
    <div className="flex items-center">
      {visibleAvatars.map((avatar, index) => (
        <div key={avatar.id ?? avatar.value ?? index} className={index === 0 ? '' : '-ml-2'}>
          {avatar.url || avatar.avatar ? (
            <img
              className="w-9 h-9 rounded-full object-cover border-1 border-white dark:border-rb-dark-mode"
              src={avatar.url || avatar.avatar}
              alt={avatar.label || 'avatar'}
            />
          ) : (
            <div className="w-9 h-9 bg-rb-green rounded-full text-white flex items-center justify-center border-1 border-white dark:border-rb-dark-mode">
              <Person />
            </div>
          )}
        </div>
      ))}
      {overflowCount > 0 && (
        <div className="-ml-2 w-9 h-9 bg-white dark:bg-rb-dark-mode rounded-full text-sm font-bold dark:text-white flex items-center justify-center border-1 border-rb-lite-grey dark:border-rb-dark-mode-lighter">
          +{overflowCount}
        </div>
      )}
    </div>
  )
}
